// DO NOT MODIFY, this file is autogenerated by tools/build.ts
// Export a null object with the same keys as firebase/compat/performance, so Proxy can work with proxy-polyfill in Internet Explorer
export const proxyPolyfillCompat = {
  app: null,
  trace: null,
  instrumentationEnabled: null,
  dataCollectionEnabled: null,
};
